import { entityDescription } from "../../common/entity";
import { useBranch } from "./hooks";

const BranchDescription = entityDescription({
  name: "branch",
  useEntity: useBranch,
});

export default BranchDescription;
